export const PRODUCT_PROMISE = "Give every code review the context of your company.";

export const BRAIN_DESCRIPTION = "The product rules and decisions RenderRepo uses when reviewing your code.";

export const REVIEWS_DESCRIPTION = "Review code against how your product is supposed to work.";

export function reviewPricingLine() {
  if (process.env.REACT_APP_REVIEW_BILLING === "true") {
    return "$1 per completed review. No repository indexing wait.";
  }
  return "No repository indexing wait. Completed reviews are not charged during the pilot.";
}

export function billingExplanation() {
  if (process.env.REACT_APP_REVIEW_BILLING === "true") {
    return "A completed review costs $1. Failed reviews are not charged. Reviewing the same commit again does not create a second charge. A new commit is a new review. A GitHub publication problem does not create another charge.";
  }
  return "Review charges are not active. A completed review does not reduce a balance yet. When billing is on, the same commit stays one review, a new commit is a new review, and a failed GitHub publication does not create a charge.";
}
